import React from "react";
import { Box, Paper, Typography } from "@mui/material";

const ChartCard = ({ title, subtitle, children, action, height = 300 }) => (
  <Paper className="glass-card" sx={{ p: 3.5, height: "100%" }}>
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: action ? 2 : 3 }}>
      <Box>
        <Typography fontWeight={700} fontSize={15} color="#1e293b">{title}</Typography>
        {subtitle && <Typography variant="caption" color="#64748b" sx={{ mt: 0.5, display: "block" }}>{subtitle}</Typography>}
      </Box>
      {action}
    </Box>
    <Box sx={{ width: "100%", height }}>
      {children}
    </Box>
  </Paper>
);

export default ChartCard;
